import { Component, Inject, OnInit, } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { CloudExtractLoadService } from '../../../dcon-modules/colud-extract-load/cloud-extract-load.service';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss']
})
export class InfoPopupComponent implements OnInit {

  public submitEnable: boolean = false;
  public extractEnable: boolean = false;
  public selectEnable: boolean = true;
  compareType: string;

  batchkey: string = null;
  constructor( public dialogRef: MatDialogRef<InfoPopupComponent>,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private celService: CloudExtractLoadService,
    private notification: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  onClickOk(val) {
    this.dialogRef.close(val);
  }

  //for legacy
  onTransform(){
    this.router.navigate(["/legacy-extract/transform"], { relativeTo: this.route });
    this.dialogRef.close();
  }

  //for cloud load
  downloadFiles() {
    const body = {
      "fileList": this.celService.configFileList
    };
    if (this.celService.configFileList.length > 0) {
      this.celService.downloadFiles(body).subscribe(res => {
        if (res.byteLength === 1176 || res.byteLength === '1176') {
          this.notification.showError('Not able to download files');
        } else {
          this.writeContents(res, 'Config_Template.zip');
          this.dialogRef.close();
        }
      },
        (error) => {
          console.log(error);
          this.notification.showError('Something went wrong!');
          this.dialogRef.close();
        });
    } else {
      this.notification.showError("There are no files list available to download !");
    }


  }

  writeContents(content, fileName) {  //contentType
    const a = document.createElement('a');
    const file = new Blob([content]); //, { type: contentType }
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

}
